import { render, staticRenderFns } from "./Decoration7.vue?vue&type=template&id=6b8b634c&scoped=true"
import script from "./Decoration7.vue?vue&type=script&lang=js"
export * from "./Decoration7.vue?vue&type=script&lang=js"
import style0 from "./Decoration7.vue?vue&type=style&index=0&id=6b8b634c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8b634c",
  null
  
)

export default component.exports